import { extendTheme } from '@chakra-ui/react';
import styles from './styles';
import Menu from './components/icon-button';
import Button from './components/button';
import Tabs from './components/tabs';
import Accordion from './components/accordion';
import BoxAccordionItem from './components/box-accordion-item';
import { StepsTheme as Steps } from "chakra-ui-steps";

let overrides = styles;
Object.assign(overrides, {
    components: {
        Button,
        Menu,
        Tabs,
        Accordion,
        BoxAccordionItem,
        Steps,
        Drawer: {
            variants: {
                alwaysOpen: {
                    parts: ['dialog, dialogContainer'],
                    dialog: {
                        pointerEvents: 'auto',
                    },
                    dialogContainer: {
                        pointerEvents: 'none',
                    }
                }
            }
        },
        Text: {
            variants: {
                MenuItem: () => ({
                    fontWeight: '500',
                    _hover: {
                        color: 'primary.700'
                    }
                })
            }
        },
        Link: {
            variants: {
                Invert: () => ({
                    fontWeight: '500',
                    color: 'primary.600',
                    _hover: {
                        color: 'primary.700',
                        textDecoration: 'none'
                    }
                })
            }
        }
    }
});

export default extendTheme(overrides);